const GlobalSearchInfo = () => {
    const shortcuts = [
        { code: 'em', description: 'Email' },
        { code: 'tm', description: 'Team Member' },
        { code: 'ph', description: 'Phone Number' },
        { code: 'cr', description: 'Campaign Request' },
        { code: 'c', description: 'Campaign' },
        { code: 'u', description: 'User' },
        { code: 'n', description: 'NTAF' },
        { code: 'mp', description: 'Medical Professional' },
        { code: 'mc', description: 'Medical Center' },
        { code: 'note', description: 'Messages' },
        { code: 'lp', description: 'Legacy Patient' },
        { code: 'np', description: 'Non-Patient Campaign' },
        { code: 'st', description: 'Staff Member' },
    ];

    return (
        <div className='mx-auto w-full p-1 text-black'>
            <h3 className='mb-4 text-left font-bold'>Search Shortcuts</h3>

            <div className=''>
                {shortcuts.map((shortcut, index) => (
                    <div key={index} className='flex justify-between pb-2'>
                        <span>{shortcut.description}</span>
                        <span className='rounded bg-[#F4F4F5] p-1 font-semibold'>
                            {shortcut.code}:
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
};
export default GlobalSearchInfo;
